{
  "RESET_PASSWORD": {
    "TITLE": "Wachtwoord opnieuw instellen",
    "DESCRIPTION": "Voer het e-mailadres in dat u gebruikt om in te loggen bij het contactcenter om instructies voor het opnieuw instellen van uw wachtwoord te ontvangen.",
    "GO_BACK_TO_LOGIN": "Als u terug wilt gaan naar de inlogpagina,",
    "EMAIL": {
      "LABEL": "E-mailadres",
      "PLACEHOLDER": "Voer uw e-mailadres in.",
      "ERROR": "Voer een geldig e-mailadres in."
    },
    "API": {
      "SUCCESS_MESSAGE": "Wachtwoord reset link is verstuurd naar uw e-mail.",
      "ERROR_MESSAGE": "Kan geen verbinding maken met de Woot server. Probeer het opnieuw."
    },
    "SUBMIT": "Bevestigen"
  }
}
